// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fixed-loader{position:fixed;right:105px;top:50px;z-index:100}", "",{"version":3,"sources":["webpack://./client/components/FixedLoader/style.scss"],"names":[],"mappings":"AAAA,cACI,cAAA,CAGA,WAAA,CADA,QAAA,CADA,WAGJ","sourcesContent":[".fixed-loader {\n    position: fixed;\n    z-index: 100;\n    top: 50px;\n    right: 105px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
